module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-info"
  }, [_c('span', {
    staticClass: "privacy-title"
  }, [_vm._v("隐私设置")]), _vm._v(" "), _c('privacy-company'), _vm._v(" "), (_vm.showIndustry) ? _c('privacy-industry') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc1fa74a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/privacySetting/index.vue
// module id = 371
// module chunks = 0